import React, { useEffect, useRef, useState } from "react";
import { Constants } from "../../CommonMethhods/Constants";
import { useDebounce } from "../../Components/useDebounce";
import axios from "axios";
import {
    AESEncryption,
    ApiResDecrypt,
    checkDateRange,
    compareDate,
    decryptData,
    encryptData,
    formatDate,
    formatDateMonth,
    noDataFound,
} from "../../CommonMethhods/CommonMethods";
import { Client_Search, MutualFund } from "../../Configuration/API_URL";
import LoaderForSearch from "../../Components/Common/LoaderForSearch";
import ReportTableHeader from "../../Components/ReportTables/ReportTableHeader";
import Loader from "../../Components/Common/Loader";
import { toast } from "react-toastify";
import moment from "moment";
import SmallLoader from "../../Components/Common/smallLoader";
export default function DigioMandate() {
    const storeToken = localStorage.getItem("ssoToken");
    const calanderIcon = true;
    const [clientList, setClientList] = useState([]);
    const [clientCode, setClientCode] = useState("");
    const [page, setPage] = useState(1);
    const [scrollLoader, setScrollLoader] = useState(false);
    const debouncedClientCode = useDebounce(clientCode, 1000);
    const [noNameFoundError, setNoNameFoundError] = useState("");
    const [count, setCount] = useState(0);
    const [fileType, setFileType] = useState("");
    const [show, setShow] = useState(false);
    const [loader, setLoader] = useState(false);
    const [smallLoaderExcel, setSmallLoaderExcel] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [dataCount, setDataCount] = useState();
    const [offset, setOffset] = useState(0);
    const [fromDate, setFromDate] = useState(
        moment().subtract(4, "days").format("MM-DD-YYYY")
    );
    const [toDate, setToDate] = useState(moment().format("MM-DD-YYYY"));
    const [scrollLoaderTable, setScrollLoaderTable] = useState(false);
    const [mainError, setMainError] = useState(false);
    const [serverError, setServerError] = useState(false);
    const [fromDateError, setFromDateError] = useState(false);
    const [errorGrid, setErrorGrid] = useState(false);
    const [errorResp, setErrorResp] = useState("");
    const [hasVerticalScroll, setHasVerticalScroll] = useState(false);
    const [sipDate, setSipDate] = useState("");
    const [expandedRowId, setExpandedRowId] = useState(null);
    const tableBodyRef = useRef(null);
    const [hasMoreData, setHasMoreData] = useState(true);
    const [search, setSearch] = useState(false)

    useEffect(() => {
        getMandateReport("grid", 0);
    }, []);
    useEffect(() => {
        if (!clientCode.trim()) {
            setShow(false);
        }
    }, [clientCode]);
    useEffect(() => {
        if (debouncedClientCode) {
            searchApiDetail(debouncedClientCode, 1);
            setScrollLoader(true);
            setClientList([]);
            setPage(1);
        }
    }, [debouncedClientCode]);
    useEffect(() => {
        if (page > 1) {
            searchApiDetail(clientCode, page);
        }
    }, [page]);
    const searchApiDetail = async (code, NoPage) => {
        const payloadValue = {
            keyword: code,
            Status: "",
            PageNo: NoPage,
            PageSize: 10,
        };
        const encPayload = AESEncryption(payloadValue);

        try {
            const response = await axios.post(
                Client_Search.Search_URL,
                `"${encPayload}"`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${storeToken}`,
                        reserv: 1,
                    },
                }
            );

            const res = ApiResDecrypt(response?.data);

            if (res?.status === 0) {
                setFileType("");
                setCount(res?.data?.TotalCount);
                setNoNameFoundError("");
                setMainError("");
                setClientList((prev) =>
                    page > 1 ? [...prev, ...res?.data?.clients] : res?.data?.clients
                );
            } else {
                setNoNameFoundError(res?.message);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setScrollLoader(false);
        }
    };

    const handleScroll = async (e) => {
        const element = e.target;
        if (
            element.scrollTop + element.offsetHeight + 1 >= element.scrollHeight &&
            !scrollLoader
        ) {
            if (count > 10 * page) {
                setPage((prev) => prev + 1);
                setScrollLoader(true);
            }
        }
    };

    const getMandateReport = async (fileView, offsetTab) => {
        if (fileView === "excel") {
            setSmallLoaderExcel(true);
        }

        if (fileView === "grid" && offsetTab <= 0) {
            setLoader(true);
            setSearch(true)
        }
        let payloadValue = {
            clientCode: clientCode,
            fromDate,
            toDate,
            offset: fileView === "grid" ? offsetTab : -1,
            limit: fileView === "grid" ? 10 : -1,
            fileType: fileView,
        };
        console.log(payloadValue, "payloadValue");

        let encPayload = AESEncryption(payloadValue);
        try {
            const getDetails = await axios.post(
                MutualFund.Digiomandate,
                `"${encPayload}"`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${storeToken}`,
                        reserv: 1,
                    },
                }
            );
            //   debugger
            const res = ApiResDecrypt(getDetails?.data);
            console.log(res, "res");

            if (res?.status === 0) {
                if (fileView === "grid") {
                    setDataCount(res?.data?.totalCount);
                    if (offsetTab > 0) {
                        setTableData((prev) => {
                            return [...prev, ...res?.data?.elssStatement];
                        });
                    } else {
                        setTableData(res?.data?.elssStatement);
                    }
                    setScrollLoaderTable(false);
                } else if (fileView === "excel") {
                    window.open(res?.data, "_self", "noopener,noreferrer");
                }
            } else {
                setTableData([]);
                if (fileView !== "grid") {
                    toast.error(res?.message);
                } else {
                    setErrorGrid(res?.message);
                }
            }
        } catch (error) {
            console.log(error);
            setServerError(error?.message);
            if (fileView !== "grid") {
                toast.error(error?.message);
            }
        } finally {
            setLoader(false);
            setSearch(false)
            setSmallLoaderExcel(false);
        }
    };
    const handleFromDateChange = (e) => {
        if (e.target.value) {
            setErrorGrid(false);
            //setTableData([]);
            setOffset(0);
            let c = e.target.value;
            const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
            setFromDate(d);
            setErrorResp(false);
            setFromDateError(false);
            setServerError(false);
            setMainError(false);
        } else {
            setFromDate("");
            setErrorGrid(false);
            //setTableData([]);
            setErrorResp(false);
            setServerError(false);
            setFromDateError(false);
        }
    };
    const handleToDateChange = (e) => {
        if (e.target.value) {
            setErrorGrid(false);
            setOffset(0);
            // setTableData([]);
            let c = e.target.value;
            const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
            setToDate(d);
            setErrorResp(false);
            setServerError(false);
            setFromDateError(false);
            setMainError(false);
        } else {
            setToDate("");
            setErrorGrid(false);
            //setTableData([]);
            setErrorResp(false);
            setServerError(false);
            setFromDateError(false);
        }
    };

    function formatDateChng(date) {
        return moment(date, "MM-DD-YYYY").format("YYYY-MM-DD");
    }

    const handleOnClick = (e) => {
        setOffset(0);
        setShow(false);
        // if (clientCode) {
        if (e.target.value) {
            if (fromDate) {
                if (
                    compareDate(fromDate) &&
                    toDate &&
                    checkDateRange(fromDate, toDate)
                ) {
                    getMandateReport(e.target.value, 0);
                    setErrorResp(false);
                    setMainError(false);
                    setFromDateError(false);
                } else {
                    setErrorResp("Please Select Mandate End Date");
                    setTableData([]);
                }
            } else if (toDate) {
                if (
                    compareDate(fromDate) &&
                    toDate &&
                    checkDateRange(fromDate, toDate)
                ) {
                    getMandateReport(e.target.value, 0);
                    setErrorResp(false);
                    setMainError(false);
                    setFromDateError(false);
                } else {
                    setErrorResp(false);
                    setFromDateError("Please Select Mandate Start Date ");
                    setTableData([]);
                }
            } else if (clientCode) {
                getMandateReport(e.target.value, 0);
                setErrorResp(false);
                setMainError(false);
                setFromDateError(false);
            }
            // else if (sipDate) {
            //   getMandateReport(e.target.value, 0);
            //   setErrorResp(false);
            //   setMainError(false);
            //   setFromDateError(false);
            // }
            else {
                setMainError("Please Select Client Name/Code or Start & End Date");
                setTableData([]);
            }
        } else {
            setMainError("Please Select Client Name/Code or Start & End Date");
            setTableData([]);
        }
    };

    // const handleTableScroll = (e) => {
    //   const a = e.target;
    //   if (
    //     a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight &&
    //     !scrollLoaderTable
    //   ) {
    //     console.log(
    //       "data count",
    //       dataCount <= 10 * offset,
    //       !(dataCount <= 10 * offset)
    //     );
    //     if (!(dataCount <= 10 * offset)) {
    //       setOffset((prev) => prev + 1);
    //       setScrollLoaderTable(true);
    //       setLoader(false);
    //       let offsetTab = offset + 1;
    //       console.log("called again from scroller");
    //       getMandateReport("grid", offsetTab);
    //     } else {
    //       setScrollLoaderTable(false);
    //     }
    //   }
    // };

    const handleTableScroll = (e) => {
        const el = e.target;
        const scrolledToBottom =
            el.scrollTop + el.offsetHeight + 1 >= el.scrollHeight;

        if (scrolledToBottom && !scrollLoaderTable) {
            const nextOffset = offset + 1;
            const totalLoadedRecords = (offset + 1) * 10;

            if (dataCount > totalLoadedRecords) {
                console.log("Loading more data from scroller...");

                setOffset(nextOffset); // This still updates state for future reference
                setScrollLoaderTable(true);
                setLoader(false);
                getMandateReport("grid", nextOffset);
            } else {
                setScrollLoaderTable(false);
            }
        }
    };

    const currentDate = new Date();
    const yyyy = currentDate.getFullYear();
    let mm = currentDate.getMonth() + 1;
    let dd = currentDate.getDate();
    if (dd < 10) dd = "0" + dd;
    if (mm < 10) mm = "0" + mm;
    const FormatedDate = dd + "/" + mm + "/" + yyyy;
    const DateReverse = FormatedDate.split("/").reverse().join("-");
    const endMandateYear = yyyy + 30;
    const endMandateFormat = dd + "/" + mm + "/" + endMandateYear;
    const endMandate = endMandateFormat.split("/").reverse().join("-");

    useEffect(() => {
        const el = tableBodyRef.current;

        if (!el) return;

        const checkScroll = () => {
            setHasVerticalScroll(el.scrollHeight > el.clientHeight);
        };

        checkScroll();

        const observer = new ResizeObserver(checkScroll);
        observer.observe(el);

        return () => observer.disconnect();
    }, [tableData]);

    return (
        <div>
            <div className="row input-field-wrapper">
                <div className="col-md-4 col-sm-4 col-12">
                    <div className="form-group">
                        <label className="form-label">Client Search</label>
                        <div className="rm-custom-dropdown">
                            <input
                                type="text"
                                className="input-st"
                                placeholder="Search here"
                                autoComplete="off"
                                value={clientCode}
                                onChange={(e) => {
                                    // const value = e.target.value?.toUpperCase();
                                    // const alphanumericValue = value.replace(/[^A-Z0-9]/gi, ""); // Allow only A-Z and 0-9

                                    const start = e.target.selectionStart;
                                    const end = e.target.selectionEnd;

                                    let input = e.target.value.toUpperCase();
                                    input = input.replace(/[^a-zA-Z0-9 ]/g, "");
                                        input = input.replace(/\s{2,}/g, " "); 
                                        input = input.replace(/^\s+/, ""); 

                                         if (input.length > 100) input = input.slice(0, 100);
                                        e.target.value = input;
                                        e.target.setSelectionRange(start, end);
                                    setClientCode(input);
                                    setShow(true);
                                }}
                            />
                            <button
                                className="rm-dropdown-btn"
                                onClick={() => setShow(!show)}
                            >
                                <span className="icon-right-arrow-triangle"></span>
                            </button>
                            {show && (
                                <ul className="rm-mapping-ap border-0" onScroll={handleScroll}>
                                    {clientList.map((item, i) => (
                                        <li
                                            key={i}
                                            className="rm-maping-item-wrapper"
                                            onClick={() => {
                                                setClientCode(item?.clientCode);
                                                setShow(false);
                                            }}
                                        >
                                            <>
                                                <div> {item?.clientname}</div>
                                                <div> {item?.clientCode}</div>
                                            </>
                                        </li>
                                    ))}
                                    {scrollLoader && !loader && (
                                        <div className="loader-center">
                                            <LoaderForSearch />
                                        </div>
                                    )}
                                    {noNameFoundError && !scrollLoader && (
                                        <li
                                            className="rm-maping-item-wrapper"
                                            style={{ borderBottom: "none", fontSize: "12px" }}
                                        >
                                            {noNameFoundError}
                                        </li>
                                    )}
                                </ul>
                            )}
                        </div>
                        {mainError && (
                            <span className="to-date-error main">{mainError}</span>
                        )}
                    </div>
                </div>
                <div className="col-md-4 col-sm-4 col-12">
                    <div className="form-group calendar-icon">
                        <label className="form-label">Start Date</label>
                        <input
                            type="date"
                            placeholder="DD/MM/YYYY"
                            className="datepicker form-control"
                            id="FromDateCombine"
                            onChange={handleFromDateChange}
                            defaultValue={formatDateChng(fromDate)}
                            max={DateReverse}
                        />
                        <span className="to-date-error">{fromDateError}</span>
                        {calanderIcon && <span className="icon-calendar ico"></span>}
                    </div>
                </div>
                <div className="col-md-4 col-sm-4 col-12">
                    <div className="form-group calendar-icon">
                        <label className="form-label">End Date</label>
                        <input
                            type="date"
                            placeholder="DD/MM/YYYY"
                            className="datepicker form-control"
                            id="ToDate"
                            onChange={handleToDateChange}
                            defaultValue={formatDateChng(toDate)}
                            // max={DateReverse}
                            max={endMandate}
                        />
                        <span className="to-date-error">{errorResp}</span>
                        {calanderIcon && <span className="icon-calendar ico"></span>}
                    </div>
                </div>
                {/* <div className="col-md-3 col-sm-3 col-6">
                    <div className="form-group calendar-icon">
                        <label className="form-label">SIP Date</label>
                        <input
                            type="date"
                            placeholder="DD/MM/YYYY"
                            className="datepicker form-control"
                            id="SipDateCombine"
                            onChange={handleSipDateChange}
                            defaultValue={formatDateChng(toDate)}
                            max={DateReverse}

                        />
                        {calanderIcon && <span className="icon-calendar ico"></span>}
                    </div>
                </div> */}
            </div>
            <div className="text-center search-btn-wrapper mb-4">
                {/* <button value="grid" className="send-message" onClick={handleOnClick}>
                    {Constants.Search}
                </button> */}
                <button
                    value="grid"
                    onClick={handleOnClick}
                    className="send-message"
                >
                    {" "}
                    {search ? (
                        <div>
                            <SmallLoader />
                        </div>
                    ) : (
                        <>

                            {"Search"}
                        </>
                    )}
                </button>
            </div>

            <div className="table-top-nav">
                <div className="table-dt-btn">
                    <button
                        value="excel"
                        onClick={handleOnClick}
                        className="generate-button excel-btn"
                    //  disabled={tableData.length > 0 ? false : true}
                    >
                        {" "}
                        {smallLoaderExcel ? (
                            <div>
                                <SmallLoader />
                            </div>
                        ) : (
                            <>
                                <span className="icon-excelsvg"></span>
                                {"Excel"}
                            </>
                        )}
                    </button>
                </div>
            </div>
            <div
                className={`mutualfund-table ${tableData?.length == 0 ? "nodatawrapper" : ""
                    }`}
            >
                {loader ? (
                    <div className="loader-alignment">
                        <Loader />
                    </div>
                ) : tableData && tableData.length > 0 ? (
                    <div className="scroll-table master_table mutualfundTab">
                        {tableData && tableData?.length > 0 ? (
                            <table className="table" style={{ width: "500%" }}>
                                <thead>
                                    <tr>
                                        <th><span className="wrap-th"><span>Utility Code</span></span></th>
                                        <th><span className="wrap-th"><span>Mandate Request ID</span></span></th>
                                        <th><span className="wrap-th"><span>Mandate Status</span></span></th>
                                        <th><span className="wrap-th"><span>Mandate Type</span></span></th>
                                        <th><span className="wrap-th"><span>Customer Ref No</span></span></th>
                                        <th><span className="wrap-th"><span>Scheme Ref No</span></span></th>
                                        <th><span className="wrap-th"><span>Customer Name</span></span></th>
                                        <th><span className="wrap-th"><span>Customer Bank</span></span></th>
                                        <th><span className="wrap-th"><span>Account Number</span></span></th>
                                        <th><span className="wrap-th"><span>Account Type</span></span></th>
                                        <th><span className="wrap-th"><span>Bank IFSC</span></span></th>
                                        <th><span className="wrap-th"><span>Customer ID</span></span></th>
                                        <th><span className="wrap-th"><span>Mobile</span></span></th>
                                        <th><span className="wrap-th"><span>Email</span></span></th>
                                        <th><span className="wrap-th"><span>Recurring</span></span></th>
                                        <th><span className="wrap-th"><span>Frequency</span></span></th>
                                        <th><span className="wrap-th"><span>Mgmt Category</span></span></th>
                                        <th><span className="wrap-th"><span>First Collection Date</span></span></th>
                                        <th><span className="wrap-th"><span>Final Collection Date</span></span></th>
                                        <th><span className="wrap-th"><span>Amount</span></span></th>
                                        <th><span className="wrap-th"><span>UMRN</span></span></th>
                                        <th><span className="wrap-th"><span>Expire On</span></span></th>
                                        <th><span className="wrap-th"><span>Corporate Config ID</span></span></th>
                                        <th><span className="wrap-th"><span>Create Date</span></span></th>
                                        {hasVerticalScroll && <th className="scrollerthead"></th>}
                                    </tr>
                                </thead>
                                <tbody
                                    onScroll={(e) => handleTableScroll(e)}
                                    id="per-table-body"
                                    ref={tableBodyRef}
                                >
                                    {tableData?.length > 0 &&
                                        tableData.map((item, index) => {
                                            const isExpanded = expandedRowId === index;
                                            const textToDisplay = item?.bseRemarks || "-";
                                            return (
                                                <tr key={index}>
                                                    <td>{item?.UtilityCode || "-"}</td>
                                                    <td>{item?.MandateRequestId || "-"}</td>
                                                    <td>{item?.DigioMandateStatus || "-"}</td>
                                                    <td>{item?.MandateType || "-"}</td>
                                                    <td>{item?.CustomerRefNumber || "-"}</td>
                                                    <td>{item?.SchemeRefNumber || "-"}</td>
                                                    <td>{item?.CustomerName || "-"}</td>
                                                    <td>{item?.CustomerBank || "-"}</td>
                                                    <td>{item?.CustomerAccountNumber || "-"}</td>
                                                    <td>{item?.CustomerAccountType || "-"}</td>
                                                    <td>{item?.CustomerBankIfsc || "-"}</td>
                                                    <td>{item?.CustomerIdentifier || "-"}</td>
                                                    <td>{item?.CustomerMobile || "-"}</td>
                                                    <td>{item?.CustomerEmail || "-"}</td>
                                                    <td>{item?.IsRecurring === 1 ? "Yes" : "No"}</td>
                                                    <td>{item?.Frequency || "-"}</td>
                                                    <td>{item?.ManagementCategory || "-"}</td>
                                                    <td>{item?.FirstCollectionDate || "-"}</td>
                                                    <td>{item?.FinalCollectionDate || "-"}</td>
                                                    <td>{item?.Amount || "-"}</td>
                                                    <td>{item?.Umrn || "-"}</td>
                                                    <td>{item?.ExpireOn || "-"}</td>
                                                    <td>{item?.CorporateConfigId || "-"}</td>
                                                    <td>{item?.CreateDate || "-"}</td>
                                                </tr>

                                            );
                                        })}
                                    {scrollLoaderTable && !loader && (
                                        <div className="loader-center">
                                            <LoaderForSearch />
                                        </div>
                                    )}
                                </tbody>
                            </table>
                        ) : (
                            noDataFound()
                        )}
                    </div>
                ) : serverError ? (
                    <h4 className="report-error-message">{noDataFound(serverError)}</h4>
                ) : errorGrid ? (
                    noDataFound(errorGrid)
                ) : (
                    ""
                )}
            </div>
        </div>
    );
}
